<template>
    <div>
        <h1 class="title">Kontakt</h1>
        <img src="../assets/EvaDoleisch_foto.jpg" alt="Eva Doleisch von Dolsperg" title="Eva Doleisch von Dolsperg">
        <br/><br/>
        Eva Doleisch von Dolsperg<br/>
        Steuerberaterin<br/>
        Engelbosteler Damm 7<br/>
        30167 Hannover<br/><br/>
        Tel. 05 11 / 16 95 16 95<br/>
        Fax 05 11 / 16 95 16 99<br/>
        <br/>
        E-Mail <a href="mailto:eva@r-doleisch.de">info@eva-doleisch.de</a>
        <br/><br/>
        <span style="font-weight:bold">U-Bahn Station</span>: An der Christuskirche
        <br/><br/>
        <iframe width="425" height="350" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"
                src="https://maps.google.de/maps?f=q&amp;source=s_q&amp;hl=de&amp;geocode=&amp;q=Engelbosteler+Damm+7,+30167,+Hannover&amp;aq=0&amp;oq=Engelbosteler+Damm+7,+30167&amp;sll=48.661847,9.003665&amp;sspn=3.178455,6.734619&amp;ie=UTF8&amp;hq=&amp;hnear=Engelbosteler+Damm+7,+30167+Hannover&amp;t=m&amp;z=14&amp;ll=52.38238,9.72521&amp;output=embed"></iframe>
        <br/>
        <small><a
                href="https://maps.google.de/maps?f=q&amp;source=embed&amp;hl=de&amp;geocode=&amp;q=Engelbosteler+Damm+7,+30167,+Hannover&amp;aq=0&amp;oq=Engelbosteler+Damm+7,+30167&amp;sll=48.661847,9.003665&amp;sspn=3.178455,6.734619&amp;ie=UTF8&amp;hq=&amp;hnear=Engelbosteler+Damm+7,+30167+Hannover&amp;t=m&amp;z=14&amp;ll=52.38238,9.72521"
                style="color:#0000FF;text-align:left">Größere Kartenansicht</a></small>

    </div>
</template>

<script>
    export default {
        data() {
            return {}
        }
    }
</script>